var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        visible: _vm.visible,
        icon: { src: "/static/icon-success-purple.svg", size: "60px" },
        title: "Sua solicitação foi enviada!"
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c("p", [
            _vm._v("Nosso time de experiência recebeu sua solicitação "),
            _c("br"),
            _vm._v("\n        e vai cuidar com muito carinho <3 ")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Fique atento aos seus emails! "),
            _c("br"),
            _vm._v("\n        Você irá receber nossa comunicação por lá."),
            _c("br"),
            _vm._v("Verifique também sua caixa de spam ;)")
          ]),
          _vm._v(" "),
          _c("base-flex", { staticClass: "mt-30" }, [
            _c(
              "div",
              {
                staticClass: "btn bg-purple-outline",
                on: {
                  click: function($event) {
                    _vm.$emit("close")
                  }
                }
              },
              [_vm._v("FECHAR")]
            )
          ])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8c31e22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8c31e22","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Freshdesk/Success/Success.vue
// module id = null
// module chunks = 